// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function isInternetExplorer() {
    return /trident|msie/i.test(window.navigator.userAgent);
}
